module.exports = __webpack_public_path__ + "img/eye.0cac0dd8.svg";